<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <div class="d-flex justify-content-center align-items-center"><h4 class="card-title mr-2">Lịch sử giao dịch</h4>  <span class="mt-1 text-secondary">Giúp bạn kiểm soát tất cả giao dịch trong báo cáo thu chi</span></div>
          </template>
          <template v-slot:body>
            <b-button v-b-modal.modal-1 variant="primary" class="my-4">
              <i class="las la-exchange-alt"/> Nạp / Rút
            </b-button>
            <div class="table-responsive">
              <b-table
                id="user-list-table"
                ref="tnxList"
                :items="tnxList"
                :fields="fields"
                :striped="false"
                :outlined="true"
                :small="true"
                :hover="true"
                :busy.sync="isBusy"
                :current-page="currentPage"
                :per-page="localItemsPerPage"
                :primary-key="'id'"
                :no-local-sorting="true"
                @sort-changed="sortChange"
                :tbody-tr-class="rowClass"
                class="table-striped table-bordered mt-1"
                role="grid"
                aria-describedby="user-list-page-info"
                show-empty
              >
                <template v-slot:cell(type)="data">
                  <b-badge pill :variant="'primary'" v-show="data.item.type === 'payment'"><span >Thanh toán</span></b-badge>
                  <b-badge pill :variant="'orange'" v-show="data.item.type === 'other'"><span >Khác</span></b-badge>
                </template>
                <template v-slot:cell(amount_vnd)="data">
                  <div>
                    <span>{{ data.item.amount_vnd | formatMoney('vi-VN','VND') }}</span>
                  </div>
                </template>
                <template v-slot:cell(amount_usd)="data">
                  <div>
                    <span>{{ data.item.amount_usd | formatMoney('en-US','USD') }}</span>
                  </div>
                </template>
                <template v-slot:cell(payment_cycle)="data">
                  <div>
                    <span>{{data.item.from_date | formatDateVN}} - {{data.item.to_date | formatDateVN}}</span>
                  </div>
                </template>
                <template v-slot:cell(created_at)="data">
                  <div>
                    <span>{{data.item.created_at | formatDateVN}}</span>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="flex align-items-center list-user-action">
                    <a
                      class="iq-bg-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      title
                      data-original-title="Xóa"
                      @click="confirmDelete(data.item.id)"
                    >
                      <i class="las la-trash-alt text-red"></i>
                    </a>
                  </div>
                </template>
                <template #empty="scope">
                  <p class="text-center">Chưa có dữ liệu</p>
                </template>
                <template #emptyfiltered="scope">
                  <p class="text-center">Không tìm thấy dữ liệu</p>
                </template>
              </b-table>
              <b-pagination
                @change="pageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="center"
                size="md"
                class="mt-3"
              ></b-pagination>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal id="modal-1" title="Nạp / rút" ok-title="Xác nhận" cancel-title="Đóng" size="sm">
      <template #modal-header>
          <h4><i class="las la-exchange-alt"/> NẠP / RÚT</h4>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
            <b-form>
              <b-form-group label="Chọn khách hàng">
                <v-select v-model="modal.customer" :options="customerOptions" placeholder="Chọn khách hàng"/>
              </b-form-group>
              <b-form-group label="Chọn chu kỳ">
                <v-select plain v-model="modal.payment_cycle" :options="rangeReportOptions" placeholder="Chọn chu kì"/>
              </b-form-group>
              <b-form-group label="Loại tiền" label-md="3">
                <b-form-radio inline v-model="modal.money_type" value="1">VND</b-form-radio>
                <b-form-radio inline v-model="modal.money_type" value="2">USD</b-form-radio>
              </b-form-group>
              <b-form-group label="Giao dịch" label-md="3">
                <b-form-radio inline v-model="modal.payment_type" name="customRadio2" value="payment">Thanh toán</b-form-radio>
                <b-form-radio inline v-model="modal.payment_type" name="customRadio2" value="other">Khác</b-form-radio>
              </b-form-group>
              <b-form-group label="Số tiền">
                <vue-numeric separator="," :precision="2" minus v-model="modal.payment_amount" class="form-control" style="text-align: right;" placeholder="nhập số" currency-symbol-position="suffix" output-type="Number"></vue-numeric>
              </b-form-group>
              <b-form-group label="Ghi chú">
                <b-form-textarea v-model="modal.note" rows="3" style="line-height: 20px"></b-form-textarea>
              </b-form-group>
              <span class="text-danger" v-html="serverError"></span>
            </b-form>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-button variant="primary" @click="confirm" :disabled="serverRequesting">Xác nhận</b-button>
        <b-button variant="default" @click="$bvModal.hide('modal-1')">Đóng</b-button>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import api from '@/store/api'
import { mapGetters } from 'vuex'

export default {
  name: 'TransactionLogList',
  async mounted () {
    findash.index()
    this.tnxList = await this.loadPage(this.currentPage, this.perPage)
  },
  data () {
    return {
      draw: 1,
      currentPage: 1,
      perPage: 50, //
      localItemsPerPage: 0, // if you want use SSR
      isBusy: false,
      ssrLength: 0,
      fields: [
        {
          key: 'type',
          label: 'Loại',
          class: 'text-center',
          thStyle: { width: '10%' }
        },
        {
          key: 'name',
          label: 'Tên khách hàng'
        },
        {
          key: 'payment_cycle',
          label: 'Chu kì'
        },
        {
          key: 'amount_vnd',
          label: 'VND',
          class: 'text-right'
        },
        {
          key: 'amount_usd',
          label: 'USD',
          class: 'text-right'
        },
        {
          key: 'note',
          label: 'Chú thích'
        },
        {
          key: 'created_at',
          label: 'Ngày giao dịch',
          class: 'text-center',
          sortable: true
        },
        {
          key: 'action',
          label: '',
          class: 'text-center'
        }
      ],
      tnxList: [],
      customerList: null, // this could be load on state of vuex (using mapState and mapAction functions)
      modal: {
        customer: null,
        payment_cycle: null,
        money_type: null,
        payment_type: null,
        payment_amount: 0,
        note: ''
      },
      modal_default_params: {
        customer: null,
        payment_cycle: null,
        money_type: null,
        payment_type: null,
        payment_amount: 0,
        note: ''
      },
      datatableColumn: {
        'columns[0][name]': 'type', // i dont know why, but first should use name instead of data...
        'columns[0][searchable]': true,
        'columns[0][orderable]': true,
        'columns[0][search][value]': '',
        'columns[0][search][regex]': false,
        'columns[1][data]': 1,
        'columns[1][name]': '',
        'columns[1][searchable]': true,
        'columns[1][orderable]': true,
        'columns[1][search][value]': '',
        'columns[1][search][regex]': false,
        'columns[2][data]': 2,
        'columns[2][name]': '',
        'columns[2][searchable]': true,
        'columns[2][orderable]': true,
        'columns[2][search][value]': '',
        'columns[2][search][regex]': false,
        'columns[3][data]': 3,
        'columns[3][name]': '',
        'columns[3][searchable]': true,
        'columns[3][orderable]': true,
        'columns[3][search][value]': '',
        'columns[3][search][regex]': false,
        'columns[4][data]': 4,
        'columns[4][name]': '',
        'columns[4][searchable]': true,
        'columns[4][orderable]': true,
        'columns[4][search][value]': '',
        'columns[4][search][regex]': false,
        'columns[5][data]': 5,
        'columns[5][name]': '',
        'columns[5][searchable]': true,
        'columns[5][orderable]': true,
        'columns[5][search][value]': '',
        'columns[5][search][regex]': false,
        'columns[6][data]': 6,
        'columns[6][name]': '',
        'columns[6][searchable]': true,
        'columns[6][orderable]': true,
        'columns[6][search][value]': '',
        'columns[6][search][regex]': false,
        'columns[7][data]': 7,
        'columns[7][name]': '',
        'columns[7][searchable]': true,
        'columns[7][orderable]': true,
        'columns[7][search][value]': '',
        'columns[7][search][regex]': false
      },
      datatableSort: {
        'order[0][column]': 6, // sort the columns[1]
        'order[0][dir]': 'desc'
      }
    }
  },
  computed: {
    totalRows () {
      return this.ssrLength
    },
    ...mapGetters({
      'customerOptions': 'Customer/listOptionsState',
      'rangeReportOptions': 'Report/rangeReportListOptionsState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    loadPage (currentPage, perPage) {
      this.isBusy = true
      let promise = api.transaction.datatables(Object.assign({
        draw: this.draw++,
        start: (currentPage * perPage) - perPage,
        length: perPage
      }, this.datatableColumn, this.datatableSort))

      return promise.then((response) => {
        const items = response.data
        this.ssrLength = parseInt(response.recordsTotal)
        this.isBusy = false
        return (items)
      }).catch(() => {
        this.isBusy = false
        return []
      })
    },
    async pageChange (page) {
      this.tnxList = await this.loadPage(page, this.perPage)
    },
    async sortChange (ctx) {
      if (ctx.sortBy === 'created_at' && ctx.sortDesc) {
        this.datatableSort['order[0][dir]'] = 'desc'
      } else {
        this.datatableSort['order[0][dir]'] = 'asc'
      }

      this.tnxList = await this.loadPage(this.currentPage, this.perPage)
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.status === '-1') return 'row-line-though'
    },
    confirm () {
      try {
        let params = {
          'member_id': this.modal.customer.id,
          'report_id': this.modal.payment_cycle.id,
          'currency_id': this.modal.money_type,
          'type': this.modal.payment_type, // enum : payment/other
          'amount': this.modal.payment_amount,
          'note': this.modal.note // optional
        }

        api.transaction.create(params).then(async () => {
          this.$swal({
            icon: 'success',
            title: 'Thêm thành công'
          })
          this.$bvModal.hide('modal-1')

          // reset form
          this.modal = this.modal_default_params
          // load list
          this.tnxList = await this.loadPage(this.currentPage, this.perPage)
        }).catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Lỗi...',
            text: this.serverError
          })
        })
      } catch {

      }
    },
    confirmDelete (id) {
      this.$swal({
        title: 'Giao dịch',
        text: 'Bạn chắc chắn xóa giao dịch này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.transaction.delete(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            // load list
            this.tnxList = await this.loadPage(this.currentPage, this.perPage)
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      }).catch(() => {
      })
    }
  }
}
</script>
